export default __webpack_public_path__ + "static/media/kitchen3-after3-2048w.a4465fbc.webp";